import { Reveal } from "./shared";
import { scrollToId } from "@/App";

export const PACKAGES = [
  { id: "1 Trainer — Half Day (£1,050)", trainers: "1 Trainer", duration: "Half day", price: "£1,050", per: "from £29 / person", features: ["3 sessions × 60 min", "Up to 36 people", "Groups of up to 12", "All equipment included"], popular: false },
  { id: "1 Trainer — Full Day (£1,900)", trainers: "1 Trainer", duration: "Full day", price: "£1,900", per: "from £26 / person", features: ["6 sessions × 60 min", "Up to 72 people", "Groups of up to 12", "All equipment included"], popular: true },
  { id: "2 Trainers — Full Day (£3,500)", trainers: "2 Trainers", duration: "Full day", price: "£3,500", per: "from £24 / person", features: ["6 sessions × 2 trainers", "Up to 144 people", "Groups of up to 12", "All equipment included"], popular: false },
  { id: "Custom quote — larger workforce", trainers: "Custom", duration: "Larger workforces", price: "Custom", per: "get in touch for a quote", features: ["Tailored session plan", "Larger groups & multiple days", "Multi-site coverage available", "Discounts for larger bookings"], popular: false },
];

export const Pricing = ({ onSelect }) => (
  <section id="pricing" className="border-y border-[#E7E3D9] bg-white px-4 py-24 sm:px-6 lg:px-8" data-testid="pricing-section">
    <div className="mx-auto max-w-7xl">
      <Reveal className="mx-auto max-w-3xl text-center">
        <h2 className="font-display text-3xl font-bold tracking-tight text-[#14231B] sm:text-4xl lg:text-5xl">
          One visit. <span className="text-[#1E7B4F]">Entire workforce.</span>
        </h2>
        <p className="mt-4 text-lg text-[#5F6E63]">
          Minimum booking: half day. Every package includes all training equipment, delivered on-site
          at your offices anywhere in the UK. Discounts available for larger groups and multiple days.
        </p>
      </Reveal>
      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {PACKAGES.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08} className="h-full">
            <div
              data-testid={`pricing-card-${i}`}
              className={`relative flex h-full flex-col rounded-3xl border bg-[#F8F7F4] p-8 text-center transition-shadow duration-300 hover:shadow-md ${
                p.popular ? "border-[#1E7B4F] shadow-lg" : "border-[#E7E3D9] shadow-sm"
              }`}
            >
              {p.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[#F97316] px-4 py-1 text-xs font-bold uppercase tracking-wide text-white">
                  Most booked
                </span>
              )}
              <p className="text-sm font-medium text-[#5F6E63]">{p.trainers}</p>
              <p className="mt-1 font-display text-lg font-semibold text-[#14231B]">{p.duration}</p>
              <p className="mt-6 font-display text-4xl font-extrabold tracking-tight text-[#14231B]">{p.price}</p>
              <p className="mt-1 text-sm font-medium text-[#F97316]">{p.per}</p>
              <ul className="mt-8 flex-1 space-y-3 text-sm text-[#5F6E63]">
                {p.features.map((f) => (
                  <li key={f} className="border-t border-[#E7E3D9] pt-3">{f}</li>
                ))}
              </ul>
              <button
                data-testid={`pricing-book-btn-${i}`}
                onClick={() => { onSelect(p.id); scrollToId("book"); }}
                className={`mt-8 w-full rounded-full py-3.5 text-sm font-semibold transition-colors duration-300 ${
                  p.popular
                    ? "bg-[#1E7B4F] text-white hover:bg-[#16603D]"
                    : "border border-[#E7E3D9] bg-white text-[#14231B] hover:bg-[#EFEDE6]"
                }`}
              >
                Enquire
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
